module.exports = __webpack_public_path__ + "static/banner-tablet-7893e295e4131481ce4039b2043b0b07.png";